import { Grid } from '@material-ui/core'
import RichTextEditor from '../../../../control/richTextEditor/richTextEditor'
import useDocumentTestResult from './useRemarkFromAdmin'
import { DocumentTestResultViewType, DocumentTestResultCtrlType } from './remarkFromAdminType'
import MyAccordion from '../../../../control/accordion/accordion'
import useTranslate from '../../../../i18n/useTranslate'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../utilities/date'

const RemarkFromAdmin = (props: DocumentTestResultViewType) => {
    const { isShow, projectData } = props
    const translate = useTranslate()
    const isStatus =
        translate.languageStore.currentLanguage === translate.languageKey.th
            ? projectData?.submittedStatusInfo?.nameTH
            : projectData?.submittedStatusInfo?.nameEN
    let isResubmitDate
    if (projectData?.resubmitDocDate) {
        isResubmitDate =
            translate.languageStore.currentLanguage === translate.languageKey.th
                ? convertDateToFormatTH(projectData?.resubmitDocDate)
                : convertDateToFormatEN(projectData?.resubmitDocDate)
    }

    return (
        <>
            {isShow && (
                <MyAccordion title={translate.get('LABEL.DOCUMENT_REVIEW_RESULT')}>
                    <Grid container spacing={4}>
                        <Grid item xl={12} lg={12} xs={12}>
                            <label>
                                {translate.get('LABEL.REVIEW_RESULT')} : {isStatus}
                            </label>
                        </Grid>
                        <Grid item xl={12} lg={12} xs={12}>
                            <label>
                                {translate.get('LABEL.RESUBMIT_DOC_DATE')} : {isResubmitDate}
                            </label>
                        </Grid>

                        <Grid item xs={12}>
                            <RichTextEditor
                                name="remarkWithFormat"
                                disabled={true}
                                initialRichTextEditor={projectData?.verifyDocumentWithFormat}
                                label={translate.get('LABEL.REMARK')}
                                placeholder={''}
                                isHideToolbar={true}
                                topicID={0}
                            />
                        </Grid>
                    </Grid>
                </MyAccordion>
            )}
        </>
    )
}

const RemarkFromAdminCtrl = (props: DocumentTestResultCtrlType) => {
    const { isViewMode } = props
    const documentTestResultCtrlModel = useDocumentTestResult({ ...props })
    return <RemarkFromAdmin {...props} {...documentTestResultCtrlModel} isViewMode={isViewMode} />
}

export default RemarkFromAdminCtrl
